import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../app/store";
import SubpageNavBarButton from "./SubpageNavBarButton";
import LoginNavButton from "./LoginNavButton";
import EASkeletonLoader from "../../../app/components/shared/EASkeletonLoader";
import { Link } from "react-router-dom";
import { GDANSK_SALE, TOUR_SALE } from "../../../app/routes";
import useFacility from "../../../utils/hooks/useFacility";
import useCustomOffer from "../../../app/components/CustomOffer/hooks/useCustomOffer";
import B2BNavButton from "./B2BNavButton";

interface IProps {
  onClick?: () => void;
}

const NaviLinks: React.FC<IProps> = ({ onClick = () => {} }) => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const facilityIds = useFacility();
  const { customOfferLinks } = useCustomOffer();
  const userData = useSelector((state: State) => state.auth.userData);

  const getPatchFromLink = (link: string) => {
    const url = new URL(link);
    const linkPath = url.pathname + url.search + url.hash;

    // Dla użytkowników B2B zachowujemy parametr id i B2BSESSION z aktualnego URL
    if (Boolean(userData.b2bType)) {
      const currentParams = new URLSearchParams(window.location.search);
      const currentId = currentParams.get("id");
      const b2bSession = currentParams.get("B2BSESSION");

      // Dodajemy parametry do URL linku
      const linkUrl = new URL(link);
      const linkParams = new URLSearchParams(linkUrl.search);

      if (currentId) {
        linkParams.set("id", currentId);
      } else if (facilityIds) {
        linkParams.set("id", facilityIds);
      }

      if (b2bSession) {
        linkParams.set("B2BSESSION", b2bSession);
      }

      const newLinkPath = linkUrl.pathname + (linkParams.toString() ? `?${linkParams.toString()}` : "") + linkUrl.hash;
      return newLinkPath;
    }

    return linkPath;
  };

  return (
    <>
      {!Boolean(userData.b2bType) ? (
        saleConfiguration.componentList ? (
          <div className={`navi-links`}>
            {saleConfiguration.componentList.map((item, index) => (
              <SubpageNavBarButton item={item} key={index} onClick={onClick} />
            ))}

            {customOfferLinks.map((item, index) => (
              <SubpageNavBarButton item={item} key={index} isCustomOffer={true} onClick={onClick} />
            ))}

            {(facilityIds === "1235" || facilityIds === "1236" || facilityIds === "1237" || facilityIds === "1238") && (
              <Link onClick={onClick} className={"navi-link"} to={GDANSK_SALE}>
                Bilety/Karnety
              </Link>
            )}

            {facilityIds === "1240" && (
              <Link onClick={onClick} className={"navi-link"} to={TOUR_SALE}>
                Bilety na występy
              </Link>
            )}

            {/* 
          {facilityIds === "1242" && (
              <Link onClick={onClick} className={"navi-link"} to={OFFER_SHOWCASE}>
                Lodowisko
              </Link>
            )} */}

            {saleConfiguration.allowToMakeAccount && <LoginNavButton onClick={onClick} />}
          </div>
        ) : (
          <EASkeletonLoader height="500px" />
        )
      ) : (
        <div className={`navi-links`}>
          {userData.b2bLinks.map((item, index) => (
            <Link key={index} onClick={onClick} className={"navi-link"} to={getPatchFromLink(item.link)}>
              {item.name}
            </Link>
          ))}
          {Boolean(userData.b2bType) && <B2BNavButton />}
        </div>
      )}
    </>
  );
};

export default NaviLinks;
